import { useNavigate } from "fusion-plugin-react-router";
import React, { useState } from "react";
import Accordion from "./accordion";

const AccordionGroup = ({ header, items }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [loadingStates, setLoadingStates] = useState({});

  return (
    <div className="accordion_group">
      <div className="accordion_header" onClick={() => setIsOpen(!isOpen)}>
        <h5>{header}</h5>
        {isOpen ? (
          <span>
            <svg
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 9V5.20001L6 0.600006L0 5.20001V9L6 4.39999L12 9Z"
                fill="#276EF1"
              />
            </svg>
          </span>
        ) : (
          <span>
            <svg
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ transform: "rotate(180deg)" }}
            >
              <path
                d="M12 9V5.20001L6 0.600006L0 5.20001V9L6 4.39999L12 9Z"
                fill="#276EF1"
              />
            </svg>
          </span>
        )}
      </div>

      {isOpen && (
        <div className="padding-x-10">
          {items.map((item, itemIndex) => (
            <>
              <Accordion
                key={item.archiveId}
                title={item.templateItemDescription || item.archiveItemDescription}
                link={item.templateDocumentGetUrl || item.archiveDocumentGetUrl}
                linkDescription={item.templateExplanation || item.archivePackExplanation}
                isLoading={loadingStates[item.archiveId] || false}
                setLoading={(isLoading) =>
                  setLoadingStates((prev) => ({
                    ...prev,
                    [item.archiveId]: isLoading,
                  }))
                }
                name={item.webDownloadFileName}
              />
            </>
          ))}
        </div>
      )}
    </div>
  );
};

export default AccordionGroup;
